import CreatorProfile from "./CreatorProfile";

export default function MsTProfile() {
  return (
    <CreatorProfile
      creatorId={13}
      categoryLabel="Blood Moon Queen"
      onlyMemberzSlug="mstigresss"
      tags={["Action", "Blood Eclipse", "ISM", "Refs Of ILL", "Collab"]}
    />
  );
}
